import { Injectable } from '@angular/core';

import { ignoreElementsTyped } from '@frontend/sports/common/core/utils/rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, filter, map, tap } from 'rxjs';

import BetslipErrorsActions from '../actions';
import { BetslipDigitalDialogFullService } from '../services/dialogs/digital/betslip-digital-dialog-full.service';
import { getStakeHints } from '../services/utils/stake-limit-errors-info-utils';

@Injectable()
export class DigitalBetslipValidationEffects {
    constructor(
        private actions$: Actions,
        private betslipFullDialogService: BetslipDigitalDialogFullService,
    ) {}

    /**
     * When the betslip is full, we are showing the BetslipFullDialog
     */
    showBetslipFullDialog$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(BetslipErrorsActions.showBetslipFullDialog),
                tap(() => this.betslipFullDialogService.show()),
                ignoreElementsTyped(),
            );
        },
        { dispatch: false },
    );

    handleStakeHintsFromBetPlacementErrors$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(BetslipErrorsActions.placeBetResponseErrors),
            map((errors) => {
                const stakeHints = getStakeHints(errors);

                return BetslipErrorsActions.setStakeFromStakeHints({ stakeHints });
            }),
        );
    });

    handleSlipStakeHints$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(BetslipErrorsActions.setStakeFromStakeHints),
            filter((stakeHints) => stakeHints.stakeHints.slipStakeHintInfos.length > 0),
            concatMap((stakeHints) => {
                const slipStakeHints = stakeHints.stakeHints.slipStakeHintInfos;

                return slipStakeHints.map((hint) => BetslipErrorsActions.setStakeFromSlipStakeHint({ slipStakeHint: hint }));
            }),
        );
    });
}
